export const config = {
  // 系统名字
  sysName: "嘀加智享车生活",
  // 系统说明
  subName: "让你的生意慧简单",
  // 是否需要注册-true;false
  hasReg: false,
  // 是否需要配置账号权限;true-有权限，从后台获取权限信息；false-无需权限
  hasAuth: true,
  subShopMerchantName: true, // 是否显示财务列表二级流量方
  env: "production",
  alipayPath: "https://dj.glsx.com.cn/dj-carlife-web-alipay/#/alipay",
  css_url:
    "https://oss-config.test.glsx.com.cn/mock/5be17454f31545347559d499/config/index.css",
  axios: {
    baseURL: "https://dj.glsx.com.cn/rop-dj-smartcarlife/router",
    appkey: "d7ffc3346fc9a45bccaaa35300d59022",
    secret: "4bc07f8868374c49a4661d603377e3106fc9a45bccaaa353",
    timeout: 50000,
    result: {
      data_key: "data",
      message_key: "message",
      code_key: "code",
      code_success_value: 0,
      code_message_map: {}
    }
  },
  axios2: {
    baseURL: "https://scrm.glsx.com.cn/rop-scrm-shopmall/router",
    appkey: "48e5e13229b82c1b4e6e8c96151f0637",
    secret: "c24619ed7fef02a0ae16328146bca5f97cc6493957a2137b",
    timeout: 50000,
    result: {
      data_key: "data",
      message_key: "message",
      code_key: "code",
      code_success_value: 0,
      code_message_map: {}
    }
  },
  common: {
    baseURL:
      "http://didicb.glsx.com.cn/router?method=glsx.accounts.biz.common.pictureUpload",
    appkey: "48e5e13229b82c1b4e6e8c96151f0637",
    secret: "c24619ed7fef02a0ae16328146bca5f97cc6493957a2137b",
    timeout: 50000,
    result: {
      data_key: "data",
      message_key: "message",
      code_key: "code",
      code_success_value: 0,
      code_message_map: {}
    }
  }
}
